export default "__VITE_ASSET__DBk71t1Z__"